import { styled } from '@mui/material';

import { useState } from 'react';

import { Link } from 'react-router';

import { useI18n } from '@app-velocity/i18n';

import { Button } from '@app-velocity/ui';

import { InfoSection } from '../../../../components/InfoSection';
import { ViewPreview } from '../../../../components/ViewPreview';

import { Viewer } from './components/Viewer';
import { ConfusionDetails } from './components/ConfusionDetails';

import { useReportContext } from '../../../../context/useReportContext';
import { ReportPaths } from '../../../../paths/ReportPaths';

const PreviewContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(8),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
}));

export const Confusions = () => {
  const { baseURL, confusions } = useReportContext();
  const { t } = useI18n();

  const [activeConfusion, setActiveConfusion] = useState(0);

  if (!confusions || confusions.highest.length === 0) return null;

  const { highest, clicksForConfussions, avgPageDuration } = confusions;

  return (
    <InfoSection tooltip="prototypes:report.confusions.tooltip">
      <InfoSection.Title title="prototypes:report.confusions.title" />
      <PreviewContainer>
        <Viewer
          onActivate={setActiveConfusion}
          slides={highest.map((confusion, index) => (
            <ViewPreview
              persona="default"
              size="large"
              key={confusion[0]}
              pageId={confusion[1].pageId}
              partials={confusion[1].partials}
              clicks={clicksForConfussions[index]}
            />
          ))}
        />
      </PreviewContainer>

      <ConfusionDetails
        confusion={highest[activeConfusion][1]}
        avgPageDuration={avgPageDuration}
      />
      <Button
        variant="contained"
        color="primary"
        component={Link}
        to={ReportPaths.goToConfusions(baseURL)}
      >
        {t('prototypes:report.confusions.see_more')}
      </Button>
    </InfoSection>
  );
};
